import React, { FC, ReactNode } from 'react';
import { Box, Card, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

interface ProjectCardProps {
  list: Array<{ title: string; text: string; svgIcon: ReactNode }>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4, 4, 8),
    borderRadius: theme.spacing(3),
    boxShadow: 'none',
    minHeight: '100%',
    [theme.breakpoints.up('sm')]: {
      minHeight: 335,
      padding: theme.spacing(4, 10, 6),
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 290,
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 271,
    },
  },
  text: {
    maxWidth: 445,
  },
}));

const ProjectCard: FC<ProjectCardProps> = ({ list = [] }) => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="space-between" spacing={5}>
      {list.map((item, index) => (
        <Grid item key={index} xs={12} sm={6}>
          <Card className={classes.root}>
            <Box mb={4}>{item.svgIcon}</Box>
            <Box mb={2}>
              <Typography variant="h4">{item.title}</Typography>
            </Box>
            <Typography variant="body2" className={classes.text}>
              {item.text}
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProjectCard;
